import * as z from "zod/v4-mini";

// DocumentReferenceのスキーマ（Firestoreの参照型）
const documentReferenceSchema = z.object({
  id: z.string(),
  path: z.string(),
});

// EventVideoGroupのスキーマ
export const EventVideoGroupSchema = z.object({
  _id: z.string(),
  _refPath: z.string(),
  eventId: z.string(),
  name: z.string(),
  priority: z.number(),
  videoGroupsSetRef: documentReferenceSchema,
});

export type EventVideoGroup = z.infer<typeof EventVideoGroupSchema>;

// EventVideoGroupsSetのスキーマ
export const EventVideoGroupsSetSchema = z.object({
  _id: z.string(),
  _refPath: z.string(),
  name: z.string(),
  priority: z.number(),
  mainVideoRef: documentReferenceSchema,
});

export type EventVideoGroupsSet = z.infer<typeof EventVideoGroupsSetSchema>;

// 現地のもぎり時に使用チケットのグループを表すスキーマ
export const TicketRedeemGroupSchema = z.object({
  _id: z.string(),
  _refPath: z.string(),
  name: z.string(),
  // 手動もぎりができるかどうかのフラグ
  isTicketRedeemingEnabled: z.boolean(),
  ticketIds: z.array(z.string()),
  // /tickets/{eventId}/issuedTicketsに存在するデータをbrowserにcacheするために必要なeventIdのリスト
  eventIds: z.array(z.string()),
});

export type TicketRedeemGroup = z.infer<typeof TicketRedeemGroupSchema>;

// IssuedTicketのスキーマ（tickets/{eventId}/issuedTickets）
// QrcodeReaderで必要なフィールドのみバリデーションし、他はpassthroughで許容
export const IssuedTicketSchema = z.looseObject({
  _id: z.string(),
  _refPath: z.string(),
  authCode: z.optional(z.string()),
  isChecked: z.optional(z.boolean()),
  isRedeemed: z.optional(z.boolean()),
  ticketId: z.optional(z.string()),
});

export type IssuedTicket = z.infer<typeof IssuedTicketSchema>;
